import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class Cursos extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.CURSOS)
            return null;

        const token = this.props.token;

        const editorFields = [
            { "label": "Nome", "name": "name" }
        ];

        const datatablesColumns = [
            {
                data: "serial",
                title: "Serial",
                width: 45,
                render: function (data, type) {
                    if (type === "display") {
                        let ret = data.toString();
                        if (ret.length === 1) return "0" + ret;
                        return ret;
                    }

                    return data;
                }
            },
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/courses/select',
            createUrl: '/api/courses/insert',
            editUrl: '/api/courses/update/_id_',
            removeUrl: '/api/courses/delete/_id_',
        });

        const editorCreateTitle = 'Inserir curso';
        const editorEditTitle = 'Editar curso';
        const editorRemoveTitle = 'Remover curso';
        const editorRemoveMessage = 'Deseja remover este curso?';

        const domClassName = 'courses-datatables';
        const title = 'Cursos';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Cursos;


// WEBPACK FOOTER //
// src/views/pages/Cursos.jsx